module.exports = ".table th, .table td {\r\n    border-top: 0px solid #eceeef;\r\n}\r\n.margin-set-left{\r\n    margin-left: 6px;\r\n}\r\n.margin-set-right{\r\n    margin-right: 6px;\r\n}\r\n.btn-mob-margin{\r\n    margin-top: 20px;\r\n}\r\n.alert-margin\r\n{\r\n    margin-top: 15px;\r\n    margin-bottom: 0px !important;\r\n}\r\n.alert\r\n{\r\n    margin-bottom: 0px !important;\r\n}\r\n.margin-10{\r\n     margin-bottom: 12px\r\n }\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/announcements/create-edit-announcement/create-edit-announcement.component.css
// module id = ./src/app/modules/announcements/create-edit-announcement/create-edit-announcement.component.css
// module chunks = main